import { useState } from "react";

export function useFormFields(initialState) {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    function(event) {
      console.log(event);
      console.log(fields)
      console.log("Updating field:", event.target.name, "=", event.target.value);

      console.log(fields)
      if (event) {
        setValues({
          ...fields,
          [event.target.name]: event.target.value
        });
      } else {
        setValues({
          ...fields
        });
      }
    }
  ];
}
